import type { ExtractPropTypes } from 'vue';
import type LivePlayer from './live-player.vue';

export const LivePlayerProps = {
  url: {
    type: String,
    default: '',
  },
  accessToken: {
    type: String,
    default: '',
  },
  debug: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否为直播
   */
  onLine: {
    type: Boolean,
    default: true,
  },
  /**
   * 萤石云播放器模板ID
   */
  playerTemplate: {
    type: String,
    default: '',
  },
};

export type LivePlayerPropsType = ExtractPropTypes<typeof LivePlayerProps>;
export type LivePlayerInstance = InstanceType<typeof LivePlayer>;
/**
 * 判断视频类型
 * @param url 视频文件的URL，支持绝对路径和相对路径
 * @returns 视频类型，支持 'flv', 'hls'，否则返回 ''
 */
export function videoType(url: string): string {
  if (!url) {
    return '';
  }

  try {
    // 提取路径名
    const pathname = extractPathname(url);
    // 去掉参数
    const pathnameWithoutParams = pathname.split('?')[0];
    // 判断视频类型
    if (pathnameWithoutParams.endsWith('.flv')) {
      return 'flv';
    } else if (pathnameWithoutParams.endsWith('.m3u8')) {
      return 'hls';
    } else {
      return '';
    }
  } catch (error) {
    console.error('URL错误或路径无效:', error);
    return '';
  }
}

/**
 * 提取路径名，支持相对路径和绝对路径
 * @param url 输入的URL
 * @returns 路径名
 */
function extractPathname(url: string): string {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    // 相对路径直接返回
    return url;
  } else {
    // 绝对路径解析
    const parsedUrl = new URL(url);
    return parsedUrl.pathname;
  }
}

export function uuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
